import m from "../../geodata/es2015/continentsHigh";
window.am4geodata_continentsHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/continentsHigh.js
// module id = null
// module chunks = 